import Card from "src/components/general/Card";
import { useGlobalLocalContext } from "src/storage/localStorage";
import type { ExtendedJSONSchema } from "../../SystemSettings.types";
import {
  type FieldEntry,
  groupFieldsBySubgroup,
  visibleSettingFields,
} from "../../SystemSettings.utils";
import SystemSettingField from "../SystemSettingField/SystemSettingField";
import SystemSettingsGroupReset from "./components/SystemSettingsGroupReset/SystemSettingsGroupReset";

interface SystemSettingsSectionContentProps {
  fields: FieldEntry[];
  form: any;
}

export default function SystemSettingsSectionContent({
  fields,
  form,
}: SystemSettingsSectionContentProps) {
  const isDebugMode = useGlobalLocalContext((state) => state.isDebugMode);

  const visible = visibleSettingFields(fields, isDebugMode);
  const subgroups = groupFieldsBySubgroup(visible);

  return (
    <div className="flex flex-col gap-6">
      {subgroups.map(({ name, fields: subgroupFields }) => (
        <section
          key={name ?? "__none__"}
          className="flex flex-col gap-4"
          data-test-id={name ? `system-settings__subgroup--${name}` : undefined}
        >
          {name ? (
            <div className="flex items-center justify-between gap-3">
              <h2 className="text-sm!">{name}</h2>
              <SystemSettingsGroupReset fields={subgroupFields} form={form} />
            </div>
          ) : (
            <SystemSettingsGroupReset fields={subgroupFields} form={form} />
          )}
          <Card className="flex flex-col gap-4">
            {subgroupFields.map(([key, options]) => (
              <SystemSettingField
                key={key}
                fieldKey={key}
                options={options}
                isHidden={(options as ExtendedJSONSchema).is_hidden ?? false}
                form={form}
              />
            ))}
          </Card>
        </section>
      ))}
    </div>
  );
}
